module.exports = __webpack_public_path__ + "img/026-storm-17.cb3d0d26.svg";